import React from 'react';
import Box from '@material-ui/core/Box';
import Typography from '@material-ui/core/Typography';
import Tooltip from '@material-ui/core/Tooltip';
import LensIcon from '@material-ui/icons/Lens';
import HelpOutlineOutlinedIcon from '@material-ui/icons/HelpOutlineOutlined';
import { useCostGrowthLegendStyles } from '../../utils/styles.esm.js';

const LegendItem = (props) => {
  const { title, tooltipText, markerColor, children } = props;
  const classes = useCostGrowthLegendStyles();
  return /* @__PURE__ */ React.createElement(Box, { display: "flex", flexDirection: "column" }, /* @__PURE__ */ React.createElement(
    Box,
    {
      minHeight: 25,
      display: "flex",
      flexDirection: "row",
      alignItems: "center"
    },
    markerColor && /* @__PURE__ */ React.createElement("div", { className: classes.marker }, /* @__PURE__ */ React.createElement(LensIcon, { style: { fontSize: "1em", fill: markerColor } })),
    /* @__PURE__ */ React.createElement(Typography, { className: classes.title, variant: "overline" }, title),
    tooltipText && /* @__PURE__ */ React.createElement(
      Tooltip,
      {
        classes: { tooltip: classes.tooltip },
        title: /* @__PURE__ */ React.createElement(Typography, { className: classes.tooltipText }, tooltipText),
        placement: "top-start"
      },
      /* @__PURE__ */ React.createElement(
        Typography,
        {
          component: "span",
          role: "img",
          "aria-label": "help",
          className: classes.helpIcon
        },
        /* @__PURE__ */ React.createElement(HelpOutlineOutlinedIcon, { fontSize: "small" })
      )
    )
  ), /* @__PURE__ */ React.createElement(Box, { marginLeft: markerColor ? "1.5em" : 0 }, /* @__PURE__ */ React.createElement(Typography, { className: classes.h5, variant: "h5" }, children)));
};

export { LegendItem };
//# sourceMappingURL=LegendItem.esm.js.map
